import React, { useEffect, useState } from 'react';
import { SectionWrapper } from '@components/Styles/CommonStyle';
import { useLoading } from '@context/LoadingContext';
import api from '@api/axios';
import { formatAmount } from '@utils/formatter';
import { theme } from '@components/Styles/theme';
import { Stack, Typography } from '@mui/material';
import {
  CustomTableContainer,
  CustomTable,
  CustomTableRow,
  CustomHeaderCell,
  CustomBodyCell,
} from '@components/Styles/TableStyle';
import { TableHead, TableBody } from '@mui/material';
import moment from 'moment';
import SectionToggle from '@components/common/Shared/SectionToggle';

const ProjectListTableFinanceV2 = ({ year, yearlyFinance }) => {
  const revenue = yearlyFinance?.total_sales
    ? yearlyFinance.total_sales -
      yearlyFinance.total_purchase -
      yearlyFinance.total_outsourcing -
      yearlyFinance.total_admin_cost -
      yearlyFinance.total_sales * 0.15
    : 0;
  const profit = yearlyFinance?.total_sales
    ? yearlyFinance.total_sales - yearlyFinance.total_purchase - yearlyFinance.total_outsourcing
    : 0;

  const localStorageOpen = localStorage.getItem("실적 현황");
  const [open, setOpen] = useState(localStorageOpen === null ? true : localStorageOpen === "true");

  return (
    <React.Fragment>
      {yearlyFinance && (
        <SectionWrapper>
          <SectionToggle title="실적 현황" open={open} setOpen={setOpen} sx={theme.typography.h4} />
          {open && (
            <CustomTableContainer>
              <CustomTable merge>
                <TableHead>
                  <CustomTableRow>
                    <CustomHeaderCell />
                    <CustomHeaderCell align="center">수익</CustomHeaderCell>
                    <CustomHeaderCell align="center">영업이익</CustomHeaderCell>
                    <CustomHeaderCell align="center">매출</CustomHeaderCell>
                    <CustomHeaderCell align="center">매입</CustomHeaderCell>
                    <CustomHeaderCell align="center">외부인건비</CustomHeaderCell>
                    <CustomHeaderCell align="center">판관비</CustomHeaderCell>
                    <CustomHeaderCell align="center">내부원가(15%)</CustomHeaderCell>
                  </CustomTableRow>
                </TableHead>
                <TableBody>
                  <CustomTableRow>
                    <CustomHeaderCell scope="row" align="center">
                      {year}
                    </CustomHeaderCell>
                    <CustomBodyCell align="right" style={{ color: revenue >= 0 ? 'blue' : 'red' }}>
                      {yearlyFinance.total_sales && formatAmount(Math.ceil(revenue))}원
                    </CustomBodyCell>
                    <CustomBodyCell align="right" style={{ color: profit >= 0 ? 'blue' : 'red' }}>
                      {yearlyFinance.total_sales && formatAmount(Math.ceil(profit))}원
                    </CustomBodyCell>
                    <CustomBodyCell align="right">
                      {yearlyFinance.total_sales && formatAmount(Math.ceil(yearlyFinance.total_sales))}원
                    </CustomBodyCell>
                    <CustomBodyCell align="right">
                      {yearlyFinance.total_purchase && formatAmount(Math.ceil(yearlyFinance.total_purchase))}원
                    </CustomBodyCell>
                    <CustomBodyCell align="right">
                      {yearlyFinance.total_outsourcing && formatAmount(Math.ceil(yearlyFinance.total_outsourcing))}원
                    </CustomBodyCell>
                    <CustomBodyCell align="right">
                      {yearlyFinance.total_admin_cost && formatAmount(Math.ceil(yearlyFinance.total_admin_cost))}원
                    </CustomBodyCell>
                    <CustomBodyCell align="right">
                      {yearlyFinance.total_sales && formatAmount(Math.ceil(yearlyFinance.total_sales * 0.15))}원
                    </CustomBodyCell>
                  </CustomTableRow>
                </TableBody>
              </CustomTable>
            </CustomTableContainer>
          )}
        </SectionWrapper>
      )}
    </React.Fragment>
  );
};

export default ProjectListTableFinanceV2;
